<template>
    <div class="">
        <div class="bg-primary text-center flex flex-col justify-center items-center text-white">
            <h3>Welcome to DMC NetBanking</h3>
            <img src="@/assets/logo.png" class="block w-40 mx-auto">
        </div>

        <div class="login-box bg-secondary rounded">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginHeader',
};
</script>

<style scoped>
.login-box {
    max-width: 900px;
    margin: 30px auto;
    border: 1px solid #ddd;
    padding: 20px;
}
</style>
